import angular from 'angular';
import ActivityTypeService from './activityType.service';
import BuildNumber from './buildNumber.service';
import CareTypeService from './careType.service';
import ChangeCategoryService from './changeCategory.service';
import CoderService from './coder.service';
import ConstantsService from './constant.service';
import DateFormatterService from './dateFormatter.service';
import FunctionService from './function.service';
import QueryModalOptionService from './queryModalOption.service';
import QueryDetailsService from './queryDetails.service';
import AuditRuleService from './auditRule.service'
import EpisodeDrgAuditTypeService from './episodeDrgAuditType.service'
import V2Service from './v2.service'
import ModalService from './modal.service';
import VersionService from './version.service';

let servicesModule = angular.module('services', [])

// Register new services here
.factory('ActivityType', ActivityTypeService)
.factory('BuildNumber', BuildNumber)
.factory('CareType', CareTypeService)
.factory('ChangeCategory', ChangeCategoryService)
.factory('CoderService', CoderService)
.factory('Constants', ConstantsService)
.factory('DateFormatter', DateFormatterService)
.factory('QueryDetails', QueryDetailsService)
.factory('FunctionService', FunctionService)
.factory('QueryModalOptions', QueryModalOptionService)
.factory('EpisodeDrgAuditTypeService', EpisodeDrgAuditTypeService)
.factory('V2Service', V2Service)
.factory('AuditRuleService', AuditRuleService)
.factory('ModalService', ModalService)
.factory('VersionService', VersionService)
;

export default servicesModule;



// WEBPACK FOOTER //
// ./client/app/common/services/services.js